// eslint-disable-next-line no-shadow
export enum BonusStatus {
  ClaimYourBonus = 'CLAIM_YOUR_BONUS',
  Spin = 'SPIN',
  BonusResult = 'BONUS_RESULT',
  WaitingForTrigger = 'WAITING_FOR_TRIGGER',
}
